/* eslint-disable @typescript-eslint/no-unused-vars */
import { FileSearchOutlined, EditOutlined, DownloadOutlined } from '@ant-design/icons';
import { Row, Col, Button, Tabs, Card, Input, Spin, Typography } from 'antd';
import ModalUpdateFile from 'components/UploadCSV';
import { billListSelectors } from 'containers/App/selectors';
import moment from 'moment';
import { resetDataTab, resetDetailInvoice } from 'pages/ListBilling/slice';
import {
  getBillProcessDetail,
  getDataExportBill,
  getDataOther,
  getDetailInvoice,
  updateFile,
  updateItemInvoice,
} from 'pages/ListBilling/thunk';
import { FC, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, Redirect } from 'react-router-dom';
import { exportFile } from 'utils/export.api';
import { HeaderListBill, BackToStepPrevBillDetail, Rectangle } from 'components';
import { t_billing_process } from 'types';
import TableCpap from './Table/TableCPAP';
import TableCpapAdd from './Table/TableCpapAdd';
import TableOther from './Table/TableOther';
import TablePSG from './Table/TablePSG';
import TableSimple from './Table/TableSimple';
import { Wrap } from './styles';

const { TabPane } = Tabs;

const { TextArea } = Input;
const { Link } = Typography;

const ListBilling: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { state } = useLocation<{ bill: t_billing_process }>();
  const { detailOther, detailInvoice, billProcessDetail } = useSelector(billListSelectors);
  const [loadTab, setLoadTab] = useState(true);
  const [keyLoad, setKeyLoad] = useState(1);
  const [loadExportBill, setLoadExportBill] = useState(false);
  const [visible, setVisible] = useState(false);
  const [file, setFile] = useState<File>();
  const formatter = new Intl.NumberFormat('ja-JP', {
    style: 'currency',
    currency: 'JPY',
  });

  const billDetail = detailInvoice ?? state.bill;

  useEffect(() => {
    if (loadTab && keyLoad === 5) {
      (async () => {
        const result: any = await dispatch(getDataOther({ invoice_id: state.bill.invoice_id }));
        const resultInvoice: any = await dispatch(getDetailInvoice({ i_id: state.bill.i_id }));
        const resultInvoices: any = await dispatch(getBillProcessDetail({ i_id: state.bill.i_id }));
        if (result.payload && resultInvoice.payload && resultInvoices.payload) {
          setLoadTab(false);
        }
      })();
    }
    return () => {
      dispatch(resetDetailInvoice());
    };
  }, [state.bill.i_id, dispatch, loadTab, keyLoad, state.bill.invoice_id]);

  const detailBill = () => {
    history.push('/billings');
  };
  const updateBill = () => {
    history.push('/billing_process/register', {
      medicalDetail: billDetail ? billDetail.lookup_items.facility_id : null,
    });
  };

  const ExportFileName = () => {
    if (
      billProcessDetail?.field_values?.find((i: { field_id: string }) => i.field_id === 'file_invoice')?.value !== null
    ) {
      return billProcessDetail?.field_values?.find((i: { field_id: string }) => i.field_id === 'file_invoice')?.value[0]
        ?.filename;
    } else {
      return '';
    }
  };

  const exportBillFile = async () => {
    if (!state) {
      return history.push('/billings');
    }
    try {
      setLoadExportBill(true);
      const dataBill: any = await dispatch(
        getDataExportBill({
          i_id: billDetail.i_id,
          facility_id: billDetail.lookup_items.facility_id.i_id,
          invoice_month: billDetail.invoice_month,
          invoice_id: billDetail.invoice_id,
        }),
      );
      await exportFile(dataBill.payload.responseBill, 'xlsx', 'BillHexabase', `${ExportFileName()}`);
      setLoadExportBill(false);
    } finally {
      setLoadExportBill(false);
    }
  };

  const exportBill = async () => {
    setLoadTab(false);
    if (!state) {
      return history.push('/billings');
    }
    try {
      setLoadExportBill(true);
      const dataBill: any = await dispatch(
        getDataExportBill({
          i_id: billDetail.i_id,
          facility_id: billDetail.lookup_items.facility_id.i_id,
          invoice_month: billDetail.invoice_month,
          invoice_id: billDetail.invoice_id,
        }),
      );

      const file = await exportFile(
        dataBill.payload.responseBill,
        'xlsx',
        'BillHexabase',
        `${billDetail.lookup_items.facility_id.facility_code || ''}_請求書_${
          billDetail.lookup_items.facility_id.facility_name
        }_${billDetail.invoice_month}`,
      );
      if (file !== 'error') {
        const resultAction: any = await dispatch(
          updateFile({
            i_id: billDetail.i_id,
            file,
            filename: `${billDetail.lookup_items.facility_id.facility_code || ''}_請求書_${
              billDetail.lookup_items.facility_id.facility_name
            }_${billDetail.invoice_month}.xlsx`,
          }),
        );
        if (updateFile.fulfilled.match(resultAction)) {
          await dispatch(
            updateItemInvoice({
              i_id: billDetail.i_id,
              data: {
                changes: [{ id: 'file_invoice', value: [resultAction.payload.file_id] }],
                use_display_id: true,
                is_force_update: true,
              },
            }),
          );
        }
      }
      if (dataBill.payload.hospitalBills) {
        setTimeout(() => {
          exportFile(
            dataBill.payload.hospitalBills,
            'xlsx',
            'DetailCPAP',
            `${billDetail.lookup_items.facility_id.facility_code}_ご使用明細書_${billDetail.lookup_items.facility_id.facility_name}_${billDetail.invoice_month}`,
          );
        }, 1000);
      }

      if (dataBill.payload.psgBills) {
        setTimeout(() => {
          exportFile(
            dataBill.payload.psgBills,
            'xlsx',
            'DetailPSG',
            `${billDetail.lookup_items.facility_id.facility_code}_PSG検査明細_${billDetail.lookup_items.facility_id.facility_name}_${billDetail.invoice_month}`,
          );
        }, 2000);
      }

      if (dataBill.payload.inspectionBills) {
        setTimeout(() => {
          exportFile(
            dataBill.payload.inspectionBills,
            'xlsx',
            'DetailInspection',
            `${billDetail.lookup_items.facility_id.facility_code}_簡易検査明細_${billDetail.lookup_items.facility_id.facility_name}_${billDetail.invoice_month}`,
          );
        }, 3000);
      }
    } finally {
      setLoadExportBill(false);
    }
    setLoadTab(true);
  };

  const renderPaymentDueDate = useMemo(() => {
    if (billDetail.payment_method === '振替' || billDetail.payment_method === '振込') {
      return moment(billDetail.payment_due_date).format('YYYY年MM月DD日');
    } else if (billDetail.payment_method === 'カード決済') {
      return 'カード会社に準ずる';
    }
    return '';
  }, [billDetail.payment_due_date, billDetail.payment_method]);

  if (!state) {
    return <Redirect to="/billings" />;
  }

  const onSubmit = async () => {
    setLoadTab(false);
    if (file) {
      const resultAction: any = await dispatch(
        updateFile({
          i_id: billDetail.i_id,
          file,
          filename: file.name,
        }),
      );
      if (updateFile.fulfilled.match(resultAction)) {
        await dispatch(
          updateItemInvoice({
            i_id: billDetail.i_id,
            data: {
              changes: [{ id: 'file_invoice', value: [resultAction.payload.file_id] }],
              use_display_id: true,
              is_force_update: true,
            },
          }),
        );
      }
      setVisible(false);
      setLoadTab(true);
    }
  };

  return (
    <Spin spinning={loadTab} size="large">
      <Wrap>
        <ModalUpdateFile
          onSubmit={() => onSubmit()}
          visible={visible}
          setVisible={setVisible}
          fileName="template_import_internal_user"
          file={file}
          setFile={setFile}
        />
        <HeaderListBill title="請求書詳細" icon={FileSearchOutlined} />
        <BackToStepPrevBillDetail backToPrev={detailBill} />
        <div className="section">
          <Row className="header-choose extraLargeFont">
            {billDetail.facility_id} {moment(billDetail.invoice_month).format('YYYY年M月度')}
          </Row>
          <Row className="logic">
            <Col style={{ textAlign: 'right' }} span={19}>
              {billDetail.Status === 'payment' ||
              billDetail.Status === 'Closed' ||
              billDetail.Status === '入金済み' ||
              billDetail.Status === '終了' ? (
                <div />
              ) : (
                <Button onClick={updateBill} className="btn-change-bill-detail">
                  {' '}
                  <EditOutlined /> 編集する
                </Button>
              )}
            </Col>
            <Col span={5}>
              <Button
                className="btn-output-pdf"
                onClick={exportBill}
                loading={loadExportBill}
                disabled={loadExportBill}
              >
                <DownloadOutlined />
                請求書PDF出力
              </Button>
            </Col>
          </Row>
          <Row>
            <Col style={{ marginTop: '-63px' }} span={24}>
              <Tabs
                defaultActiveKey="1"
                type="card"
                onTabClick={(key) => {
                  dispatch(resetDataTab());
                  setKeyLoad(Number(key));
                  setLoadTab(true);
                }}
                size={'small'}
              >
                <TabPane tab="CPAP利用明細" key="1">
                  <Row>
                    <Col span={20} className="extraLargeFont">
                      CPAP利用明細作成
                    </Col>
                    <Col span={4} className="smallFont">
                      最大請求月数：{billDetail.billable_month}ヶ月分
                    </Col>
                  </Row>
                  <Row className="table">
                    <Col span={23}>
                      <TableCpap loadData={loadTab && keyLoad === 1} setLoadData={setLoadTab} bill={billDetail} />
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '24px' }}>
                    <Col className="extraLargeFont" span={23}>
                      この請求月に追加した明細
                    </Col>
                  </Row>
                  <Row className="table">
                    <Col span={23}>
                      <TableCpapAdd loadData={keyLoad === 1} bill={billDetail} />
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="出張PSG検査明細" key="2">
                  <Row>
                    <Col className="extraLargeFont" span={23}>
                      出張PSG検査明細
                    </Col>
                  </Row>
                  <Row>
                    <Col span={23}>
                      <TablePSG loadData={loadTab && keyLoad === 2} setLoadData={setLoadTab} bill={billDetail} />
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="簡易検査明細" key="3">
                  <Row>
                    <Col className="extraLargeFont" span={23}>
                      簡易検査明細
                    </Col>
                  </Row>
                  <Row>
                    <Col span={23}>
                      <TableSimple loadData={loadTab && keyLoad === 3} setLoadData={setLoadTab} bill={billDetail} />
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="その他明細" key="4">
                  <Row>
                    <Col className="extraLargeFont" span={23}>
                      その他明細
                    </Col>
                  </Row>
                  <Row>
                    <Col span={23}>
                      <TableOther loadData={loadTab && keyLoad === 4} setLoadData={setLoadTab} bill={billDetail} />
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tab="請求書" key="5">
                  <Row>
                    <Col span={23}>
                      <div className="invoice">
                        <div className="title">
                          <Rectangle text="請求内容" />
                        </div>
                        <div className="bill">
                          <div className="mgrl-25">
                            {' '}
                            <Row className="dl">
                              <Col span={4}>
                                <Card className="w-card w-gb-gr smallBoldFont" title="前回請求額">
                                  <div className="money-info">
                                    {formatter.format(Number(billDetail.last_billed_amount))}
                                  </div>
                                </Card>
                              </Col>
                              <Col span={4}>
                                <Card className="w-card w-gb-gr smallBoldFont" title="前回入金額">
                                  <div className="money-info">{formatter.format(Number(billDetail.last_deposit))}</div>
                                </Card>
                              </Col>
                              <Col span={4}>
                                <Card className="w-card w-gb-gr smallBoldFont" title="繰越金額">
                                  <div className="money-info">
                                    {formatter.format(Number(billDetail.carryover_amount))}
                                  </div>
                                </Card>
                              </Col>
                              <Col style={{ color: 'black' }} span={4}>
                                <Card className="w-card w-bg-ec smallBoldFont" title="当月請求額">
                                  <div className="money-info"> {formatter.format(Number(billDetail.total))}</div>
                                </Card>
                              </Col>
                              <Col span={4}>
                                <Card className="w-card w-bg smallBoldFont" title="合計請求額">
                                  <div className="money-info">
                                    {' '}
                                    {formatter.format(Number(billDetail.billing_amount))}
                                  </div>
                                </Card>
                              </Col>
                            </Row>
                          </div>
                          <div className="pay">
                            <div className="wrap-bill pd-15">
                              <Row className="bd-style pd-15">
                                <Col className="middleBoldFont" span={19}>
                                  お取引先番号
                                </Col>
                                <Col className="middleBoldFont" style={{ textAlign: 'right' }} span={5}>
                                  {billDetail.facility_code}
                                </Col>
                              </Row>
                            </div>
                            <div className="wrap-bill pd-15">
                              <Row className="bd-style pd-15">
                                <Col className="smallBoldFont" span={7}>
                                  CPAP療法レンタル
                                </Col>
                                <Col span={3}>数量</Col>
                                <Col span={3}>{billDetail.cpap_count}</Col>
                                <Col span={3}>単価</Col>
                                <Col span={4}>{billDetail.cpap_unit_price}円</Col>
                                <Col className="standardBoldFont t-al" span={4}>
                                  {formatter
                                    .format(Number(billDetail.cpap_count) * Number(billDetail.cpap_unit_price))
                                    .slice(1)}
                                  円
                                </Col>
                              </Row>
                            </div>
                            <div className="wrap-bill pd-15">
                              <Row className="bd-style pd-15">
                                <Col className="smallBoldFont" span={7}>
                                  CPAP療法レンタル(特別料金)
                                </Col>
                                <Col span={3}>数量</Col>
                                <Col span={3}>{billDetail.cpap_sp_count}</Col>
                                <Col span={3}>単価</Col>
                                <Col span={4}>{billDetail.cpap_unit_sp_price}円</Col>
                                <Col className="standardBoldFont t-al" span={4}>
                                  {formatter
                                    .format(Number(billDetail.cpap_sp_count) * Number(billDetail.cpap_unit_sp_price))
                                    .slice(1)}
                                  円
                                </Col>
                              </Row>
                            </div>
                            <div className="wrap-bill pd-15">
                              <Row className="bd-style pd-15">
                                <Col className="smallBoldFont" span={7}>
                                  出張PSG検査料
                                </Col>
                                <Col span={3}>数量</Col>
                                <Col span={3}>{billDetail.psg_count}</Col>
                                <Col span={3}>単価</Col>
                                <Col span={4}>{billDetail.psg_unit_price}円</Col>
                                <Col className="standardBoldFont t-al" span={4}>
                                  {formatter
                                    .format(Number(billDetail.psg_count) * Number(billDetail.psg_unit_price))
                                    .slice(1)}
                                  円
                                </Col>
                              </Row>
                            </div>
                            <div className="wrap-bill pd-15">
                              <Row className="bd-style pd-15">
                                <Col className="smallBoldFont" span={7}>
                                  簡易PSG検査料
                                </Col>
                                <Col span={3}>数量</Col>
                                <Col span={3}>{billDetail.simplicity_count}</Col>
                                <Col span={3}>単価</Col>
                                <Col span={4}>{billDetail.simplicity_unit_price}円</Col>
                                <Col className="standardBoldFont t-al" span={4}>
                                  {formatter
                                    .format(
                                      Number(billDetail.simplicity_count) * Number(billDetail.simplicity_unit_price),
                                    )
                                    .slice(1)}
                                  円
                                </Col>
                              </Row>
                            </div>
                            {detailOther &&
                              detailOther.map((other, index) => (
                                <div
                                  key={index}
                                  className={index < detailOther.length - 1 ? 'wrap-bill pd-15' : 'wrap-bill'}
                                >
                                  <Row className="bd-style pd-15">
                                    <Col className="smallBoldFont" span={7}>
                                      {other.detail_name ?? ''}
                                    </Col>
                                    <Col span={3}>数量</Col>
                                    <Col span={3}>{other.other_detail_count ?? 0}</Col>
                                    <Col span={3}>単価</Col>
                                    <Col span={4}>{other.other_detail_unit_price ?? 0}円</Col>
                                    <Col className="standardBoldFont t-al" span={4}>
                                      {(
                                        Number(other.other_detail_count ?? 0) *
                                        Number(other.other_detail_unit_price ?? 0)
                                      )?.toLocaleString()}
                                      円
                                    </Col>
                                  </Row>
                                </div>
                              ))}
                            <div className="wrap-bill pd-15">
                              <Row className="pd-15">
                                <Col className="pdt-60" span={14}>
                                  <Row className="tb-height">
                                    <Col className="col-fl smallBoldFont bd-bt" span={6}>
                                      支払い条件
                                    </Col>
                                    <Col className="col-fl-2 bd-bt" span={9}>
                                      {billDetail.payment_method}
                                    </Col>
                                  </Row>
                                  <Row className="tb-height">
                                    <Col className="col-fl smallBoldFont" span={6}>
                                      支払期日
                                    </Col>
                                    <Col className="col-fl-2" span={9}>
                                      {renderPaymentDueDate}
                                    </Col>
                                  </Row>
                                </Col>
                                <Col span={10}>
                                  <Row className="detail-bill pd-15 bd-solid">
                                    <Col className="standardFont" span={10}>
                                      小計
                                    </Col>
                                    <Col className="t-al standardBoldFont" span={14}>
                                      {Number(billDetail.subtotal)?.toLocaleString()}円
                                    </Col>
                                  </Row>
                                  <Row className="detail-bill pd-15 bd-solid">
                                    <Col className="standardFont" span={10}>
                                      消費税(10%)
                                    </Col>
                                    <Col className="t-al standardBoldFont" span={14}>
                                      {Number(billDetail.tax)?.toLocaleString()}円
                                    </Col>
                                  </Row>
                                  <Row className="detail-bill pd-15 bd-solid-2">
                                    <Col className="standardBoldFont" span={10}>
                                      合計
                                    </Col>
                                    <Col className="t-al standardBoldFont" span={14}>
                                      {roundNumber(Number(billDetail.total))?.toLocaleString()}円
                                    </Col>
                                  </Row>
                                  <Row className="smallFont" style={{ textAlign: 'right' }}>
                                    <Col span={24}>※10円未満切り捨て</Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                            <Row className="wrap-bill pd-30">
                              <Col className="smallBoldFont pd-7" span={24}>
                                備考
                              </Col>
                              <Col span={24}>
                                <TextArea className="txt-area" value={billDetail.invoice_remark} />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                      <div className="invoice">
                        <div className="title">
                          <Rectangle text="請求書ファイル" />
                        </div>
                        <div className="content-xlsx">
                          <p>
                            請求書出力時に自動で保存されたエクセルファイルです。手動で編集した場合はファイルを更新してください。
                          </p>
                          <div className="btn-xlsx">
                            {ExportFileName() === '' ? (
                              ''
                            ) : (
                              <Link target="_blank" className="name-xlsx" onClick={() => exportBillFile()}>
                                {ExportFileName()}
                              </Link>
                            )}
                            <div>
                              <Button
                                className="btn-output-pdf"
                                onClick={exportBillFile}
                                loading={loadExportBill}
                                disabled={!ExportFileName()}
                              >
                                ダウンロード
                              </Button>
                              <Button
                                className="btn-output-pdf"
                                onClick={() => setVisible(true)}
                                disabled={loadExportBill}
                              >
                                更新する
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </Col>
          </Row>
        </div>
      </Wrap>
    </Spin>
  );
};

const roundNumber = (num: number) => {
  return Math.floor(num / 10) * 10;
};

export default ListBilling;
